import { useMemo } from 'react';

const useWhatsappLink = (number?: string, contactName?: string) => useMemo(() => {
  let link;
  let formattedNumber = number;

  if (formattedNumber && contactName) {
    if (/^06\d{8}/.test(formattedNumber)) {
      formattedNumber = formattedNumber.replace(/^06/, '+316');
    }

    if (/^\+\d+}/.test(formattedNumber)) {
      formattedNumber = formattedNumber.replace(/^\+/, '00');
    }

    link = `https://wa.me/${formattedNumber}`;
    if (contactName) {
      link += `?text=${encodeURIComponent(contactName)}`;
    }
  }

  return link;
}, [number, contactName]);

export default useWhatsappLink;
